import styled from "styled-components";

export const ShippingPageContainer = styled.div``;
